/**
 * @fileoverview DELETE handler for the "/apps/:app_group_id/custom_events_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomEventsSettingsCacheKeys } from "./constants";
import type {
  DeleteAppsAppGroupIdCustomEventsSettingsProps,
  AppsAppGroupIdCustomEventsSettingsResult,
} from "./types";

export const deleteAppsAppGroupIdCustomEventsSettings = reactQueryMutationAdapter(
  appsAppGroupIdCustomEventsSettingsCacheKeys,
  (props: DeleteAppsAppGroupIdCustomEventsSettingsProps): Promise<AppsAppGroupIdCustomEventsSettingsResult> =>
    fetch(`/apps/${props.appGroupId}/custom_events_settings`, "DELETE", props)
);
